import React, { useState, useEffect, useRef } from "react";
import Header from "../Common_Files/Header";
import Footer from "../Common_Files/Footer";
import config from '../Common_Files/Config';
import ViewProduct from "../Master/ViewProduct";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $, { event } from "jquery";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

const Products = () => {
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [productData, setProductData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [editProduct, setEditProduct] = useState([]);
  const [vatData, setVatData] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [viewProductId, setViewProductId] = useState(null);
  const modalRef = useRef(null);
  const updateModalRef = useRef(null);
  const tableRef = useRef(null);
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    fetchWarehouseData();
  }, []);

  const fetchData = async () => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    const searchValue = $('#product_name').val();
    const location_name = $('#location_name').val();
    const warehouse_id = $('#warehouse_id').val() || 'all';
    const stock_type = $('#stock_type').val();

    const formData = new FormData();
    formData.append("draw", draw);
    formData.append("start", start);
    formData.append("length", length);
    formData.append("searchValue", searchValue);
    formData.append("location_name", location_name);
    formData.append("warehouse_id", warehouse_id);
    formData.append("stock_type", stock_type);

    const apiUrl = `${config.api_url}/get-products-list`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });
      const data = await response.json();
      setProductData(data.products);
    } catch (error) {
      console.error("Error fetching new sales data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchSupplierData = async () => {
    const apiUrl = `${config.api_url}/ws-get-suppliers`;
    try {
      const response = await axios.post(apiUrl, null, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      const data = response.data;
      setSupplierData(data.supplier);
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchCategoryData = async () => {
    const apiUrl = `${config.api_url}/ws-get-category`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });
      const data = await response.json();
      setCategoryData(data.category);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };

  const updateProductForm = async () => {
    const formElement = document.getElementById('editProductForm');
    const formData = new FormData(formElement);
    var product_desc = $('#edit_product_desc').val();
    var product_code = $('#edit_product_code').val();
    var min_threshold_qty = $('#edit_min_threshold_qty').val();
    var return_check = 0;

    if (product_desc === '') {
      $('#edit_product_desc_error').show();
      return_check = 1;
    } else {
      $('#edit_product_desc_error').hide();
    }

    if (product_code === '') {
      $('#edit_product_code_error').show();
      return_check = 1;
    } else if (product_code.length < 3 || product_code.length > 8) {
      $('#edit_product_code_error').text('Product code must be between 3 and 8 characters').show();
      return_check = 1;
    } else if (!/^[A-Z0-9]+$/.test(product_code)) {
      $('#edit_product_code_error').text('Product code must be alphanumeric and uppercase').show();
      return_check = 1;
    } else {
      $('#edit_product_code_error').hide();
    }

    const currentProductId = $('#edit_product_id').val();
    const unitBarcode = $('#edit_unit_barcode').val();
    const caseBarcode = $('#edit_case_barcode').val();
    
    if (unitBarcode && unitBarcode.trim() !== '') {
      const unitBarcodeValid = await handleBarcodeBlur(unitBarcode, 'unit', '#edit_unit_barcode_error', '#edit_unit_barcode_product_info', currentProductId);
      if (!unitBarcodeValid) {
        return_check = 1;
      }
    }

    if (caseBarcode && caseBarcode.trim() !== '') {
      const caseBarcodeValid = await handleBarcodeBlur(caseBarcode, 'case', '#edit_case_barcode_error', '#edit_case_barcode_product_info', currentProductId);
      if (!caseBarcodeValid) {
        return_check = 1;
      }
    }

    if (return_check == 1) {
      if (unitBarcode || caseBarcode) {
        Swal.fire({
          title: 'Error!',
          text: 'Duplicate barcode detected. Please use a different barcode.',
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-high-z-index'
          }
        });
      }
      return;
    }

    let a = formData.get("status");
    formData.set("status", formData.get("status") === "on" ? 1 : 0);

    try {
      const response = await fetch(`${config.api_url}/ws-update-product`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: 'Success!',
          text: 'Product updated successfully.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-high-z-index'
          }
        });

        const bsModal = window.bootstrap.Modal.getInstance(updateModalRef.current);
        if (bsModal) bsModal.hide();

        const table = $("#productListTable").DataTable();
        table.ajax.reload();
      } else {
        Swal.fire({
          title: 'Error!',
          text: result.message || 'An error occurred while updating the product.',
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-high-z-index'
          }
        });
      }
    } catch (error) {
      console.error("Error updating product:", error);
      Swal.fire({
        title: 'Error!',
        text: 'Network error occurred while updating the product.',
        icon: 'error',
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          popup: 'swal-high-z-index'
        }
      });
    }
  };

  useEffect(() => {
    // Destroy existing table if it exists
    if ($.fn.DataTable.isDataTable('#productListTable')) {
      $('#productListTable').DataTable().destroy();
    }

    const table = $("#productListTable").DataTable({
      serverSide: true,
      processing: true,
      ajax: async (data, callback) => {
        const searchValue = $('#product_name').val();
        const location_name = $('#location_name').val();
        const warehouse_id = $('#warehouse_id').val() || 'all';
        const stock_type = $('#stock_type').val();

        const formData = new FormData();
        formData.append("draw", data.draw);
        formData.append("start", data.start);
        formData.append("length", data.length);
        formData.append("searchValue", searchValue);
        formData.append("location_name", location_name);
        formData.append("warehouse_id", warehouse_id);
        formData.append("stock_type", stock_type);

        try {
          const response = await fetch(`${config.api_url}/get-products-list`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          });
          const result = await response.json();

          callback({
            draw: result.draw,
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: result.products,
          });
        } catch (err) {
          console.error("DataTables AJAX error:", err);
        }
      },
      pageLength: 50,
      lengthMenu: [10, 20, 50],
      searching: true,
      ordering: true,
      autoWidth: false,
      scrollX: true,
      dom: '<"top"lf>rt<"bottom"<"row"<"col-sm-6"i><"col-sm-6"p>>><"clear">',
      columnDefs: [
        { orderable: false, targets: "_all" },
        { width: "80px", targets: 0 },      // Code
        { width: "200px", targets: 1 },     // Product Description
        { width: "60px", targets: 2 },      // Pack
        { width: "80px", targets: 3 },      // Size
        { width: "120px", targets: 4 },     // Unit Barcode
        { width: "120px", targets: 5 },     // Case Barcode
        { width: "80px", targets: 6 },      // Pallet Qty
        { width: "80px", targets: 7 },      // Layer Qty
        { width: "80px", targets: 8 },      // Gross Wt
        { width: "80px", targets: 9 },      // Net Wt
        { width: "70px", targets: 10 },     // CBM
        { width: "120px", targets: 11 },    // Category
        { width: "90px", targets: 12 },     // Sell price
        { width: "70px", targets: 13 },     // F. Stk
        { width: "70px", targets: 14 },     // On SO
        { width: "70px", targets: 15 },     // On PO
        { width: "70px", targets: 16 },     // Stock
        { width: "80px", targets: 17 },     // Status
        { width: "90px", targets: 18 }      // Action
      ],
      columns: [
        { data: "code" },
        { data: "product_desc" },
        { data: "pack" },
        { data: "size" },
        { data: "unit_barcode" },
        { data: "case_barcode" },
        { data: "pallet_qty" },
        { data: "layer_qty" },
        {
          data: "gross_weight",
          render: function (data, type, row) {
            const isDEL001 = row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001';
            return isDEL001 ? 0 : (data || 0);
          },
        },
        {
          data: "net_weight",
          render: function (data, type, row) {
            const isDEL001 = row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001';
            return isDEL001 ? 0 : (data || 0);
          },
        },
        { data: "cbm" },
        { data: "category" },
        { data: "price" },
        {
          data: "freestock",
          render: function (data, type, row) {
            const isDEL001 = row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001';
            return isDEL001 ? 0 : (data || 0);
          },
        },
        {
          data: "onso",
          render: function (data, type, row) {
            const isDEL001 = row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001';
            return isDEL001 ? 0 : (data || 0);
          },
        },
        {
          data: "onpo",
          render: function (data, type, row) {
            return data?.totalPO ?? "-";
          },
        },
        { data: "quantity" },
        {
          data: "status",
          render: function (data) {
            return data == 1 ? "Active" : "Inactive";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            const isSpecialLineItem = row.code === 'DEL001' || row.code?.toUpperCase() === 'DEL001';
            if (isSpecialLineItem) {
              return '';
            }
            return `
            <a href="#" class="applybtn" data-id="${row.id}" data-bs-toggle="modal" data-bs-target="#viewproduct">
              <i class="fa fa-eye"></i> 
            </a>
            <a href="#" class="deductionbtn" data-id="${row.id}" data-bs-toggle="modal" data-bs-target="#edit-product">
              <i class="fa fa-edit"></i> 
            </a>`;
          },
        },
      ],
      initComplete: function() {
        // Column alignment fix
        const alignColumns = () => {
          const api = this.api();
          const settings = api.settings()[0];
          const scrollHead = $(settings.nScrollHead);
          const scrollBody = $(settings.nScrollBody);
          
          // Get header and body tables
          const headerTable = scrollHead.find('table');
          const bodyTable = scrollBody.find('table');
          
          if (headerTable.length && bodyTable.length) {
            // Force same width on both tables
            const bodyWidth = bodyTable.width();
            headerTable.width(bodyWidth);
            
            // Align each column
            headerTable.find('thead th').each(function(index) {
              const headerCell = $(this);
              const bodyCell = bodyTable.find('tbody tr:first td').eq(index);
              
              if (bodyCell.length) {
                const width = bodyCell.outerWidth();
                headerCell.outerWidth(width);
              }
            });
                }
        };
              
        // Run alignment multiple times to ensure it sticks
        setTimeout(() => alignColumns(), 100);
        setTimeout(() => alignColumns(), 300);
        setTimeout(() => alignColumns(), 600);
        
        // Re-align on window resize
        $(window).off('resize.productTable').on('resize.productTable', function() {
          clearTimeout(window.productTableResizeTimer);
          window.productTableResizeTimer = setTimeout(() => {
            alignColumns();
          }, 150);
        });
      },
      drawCallback: function() {
        // Re-align columns after each draw
        const api = this.api();
        const settings = api.settings()[0];
        const scrollHead = $(settings.nScrollHead);
        const scrollBody = $(settings.nScrollBody);
        
        const headerTable = scrollHead.find('table');
        const bodyTable = scrollBody.find('table');
        
        if (headerTable.length && bodyTable.length) {
          const bodyWidth = bodyTable.width();
          headerTable.width(bodyWidth);
          
          headerTable.find('thead th').each(function(index) {
            const headerCell = $(this);
            const bodyCell = bodyTable.find('tbody tr:first td').eq(index);
            
            if (bodyCell.length) {
              const width = bodyCell.outerWidth();
              headerCell.outerWidth(width);
              }
            });
        }
            
        // Run once more after a brief delay
    setTimeout(() => {
          if (headerTable.length && bodyTable.length) {
            headerTable.find('thead th').each(function(index) {
              const headerCell = $(this);
              const bodyCell = bodyTable.find('tbody tr:first td').eq(index);
              
              if (bodyCell.length) {
                const width = bodyCell.outerWidth();
                headerCell.outerWidth(width);
        }
            });
      }
        }, 50);
      }
    });

    return () => {
      $(window).off('resize.productTable');
      if ($.fn.DataTable.isDataTable('#productListTable')) {
        $('#productListTable').DataTable().destroy();
      }
    };
  }, []);

  const setAjaxSearch = () => {
    const table = $("#productListTable").DataTable();
    if (table) {
      table.ajax.reload();
    }
  }

  useEffect(() => {
    $('#productListTable tbody').off('click', '.applybtn');
    $('#productListTable tbody').on('click', '.applybtn', function () {
      $('#freestock').empty();
      $('#stock').empty();
      $('#on_so').empty();
      $('#allocation').empty();
      $('#onpf').empty();
      $('#onpo').empty();
      const product_id = $(this).data('id');
      setViewProductId(product_id);
      const formData = new FormData();
      formData.append('id', product_id);
      document.getElementById('viewProductForm').reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
          });

          const data = await response.json();
          $('#code').val(data.products[0].code);
          $('#packValue').val(data.products[0].pack);
          $('#vat').val(data.products[0].vat);
          $('#weight').val(data.products[0].gross_weight);
          $('#supplier').val(data.products[0].supplier_name);
          $('#description').val(data.products[0].product_desc);
          $('#sizeValue').val(data.products[0].size);
          $('#barcode').val(data.products[0].unit_barcode);
          $('#view_case_barcode').val(data.products[0].case_barcode);
          $('#pallet_qty').val(data.products[0].pallet_qty);
          $('#case_price').val(data.products[0].cost);
          $('#view_sell_price').val(data.products[0].price);
          $("#product_status").html(data.products[0].status != 0
            ? 'Status : <span style="margin-left: 5px;" class="badge bg-success">Active</span>'
            : 'Status : <span style="margin-left: 5px;" class="badge bg-secondary"> Inactive</span>'
          );
          $('#viewcbm').val(data.products[0].cbm);
          $('#brandname').val(data.products[0].brand);
          $('#categooryName').val(data.products[0].category);
          $('#editnetWeight').val(data.products[0].net_weight);
          $('#editgrossWeight').val(data.products[0].price);
          let freeStockVal = parseInt(data.freestock) + parseInt(data.products[0].quantity);
          $('#freestock').append(isNaN(freeStockVal) ? 0 : freeStockVal);

          $('#stock').append(parseInt(data.products[0].quantity));
          $('#on_so').append(data.onso == null ? 0 : data.onso);
          $('#allocation').append(data.allocation == null ? 0 : data.allocation);
          $('#onpf').append(data.pf == null ? 0 : data.pf);
          $('#onpo').append(data.on_purchase == null ? 0 : data.on_purchase);
        }
        catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $('#productListTable tbody').off('click', '.applybtn');
    };
  }, []);

  useEffect(() => {
    $('#productListTable tbody').off('click', '.deductionbtn');
    $('#productListTable tbody').on('click', '.deductionbtn', function () {
      $('#edit_product_desc_error').hide();
      $('#edit_product_code_error').hide();
      fetchBrandData();
      fetchSupplierData();
      fetchCategoryData();
      fetchVatData();
      const supplier_id = $(this).data('id');
      const formData = new FormData();
      formData.append('id', supplier_id);
      document.getElementById('editProductForm').reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
          });

          const data = await response.json();
          $('#edit_product_desc').val(data.products[0].product_desc);
          $('#edit_product_code').val(data.products[0].code);
          $('#edit_category_id').val(data.products[0].category_id).change();
          $('#edit_supplier_id').val(data.products[0].supplier_id).change();
          $('#edit_brand_id').val(data.products[0].brand_id).change();
          $('#edit_vat_id').val(data.products[0].vat_id).change();
          $('#edit_pack').val(data.products[0].pack);
          $('#edit_size').val(data.products[0].size);
          $('#edit_pallet_quantity').val(data.products[0].pallet_qty);
          $('#edit_layer_quantity').val(data.products[0].layer_qty);
          $('#edit_unit_barcode').val(data.products[0].unit_barcode);
          $('#edit_case_barcode').val(data.products[0].case_barcode);
          $('#edit_min_threshold_qty').val(data.products[0].min_threshold_qty);
          $('#edit_case_weight').val(data.products[0].weight);
          $('#length').val(data.products[0].length);
          $('#length_unit').val(data.products[0].length_unit).change();
          $('#width').val(data.products[0].width);
          $('#width_unit').val(data.products[0].width_unit).change();
          $('#height').val(data.products[0].height);
          $('#height_unit').val(data.products[0].height_unit).change();
          $('#edit_cost_price').val(data.products[0].cost);
          $('#edit_sell_price').val(data.products[0].price);
          $('#edit_product_id').val(data.products[0].id);
          $('#edit_grossWeight').val(data.products[0].gross_weight);
          $('#edit_netWeight').val(data.products[0].net_weight);
          $('#edit_cbm').val(data.products[0].cbm);
          $('#edit_prev_image').attr('src', data.products[0].image);
          $('#edit_oldPdtImg').val(data.products[0].image);
          const url = '';
          if (data.products[0].status == "1") {
            $('#edit_status').prop('checked', true);
          }
        } catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $('#productListTable tbody').off('click', '.deductionbtn');
    };
  }, []);

  const checkBarcodeExists = async (barcode, barcodeType, excludeProductId = null) => {
    if (!barcode || barcode.trim() === '') {
      return null;
    }

    try {
      const formData = new FormData();
      formData.append('barcode', barcode.trim());
      formData.append('barcode_type', barcodeType);
      if (excludeProductId) {
        formData.append('exclude_product_id', excludeProductId);
      }

      const response = await fetch(`${config.api_url}/ws-check-barcode-exists`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });

      const result = await response.json();
      return result.product || null;
    } catch (error) {
      console.error("Error checking barcode:", error);
      return null;
    }
  };

  const handleBarcodeBlur = async (barcodeValue, barcodeType, errorElementId, productInfoElementId, currentProductId = null) => {
    const errorElement = $(errorElementId);
    const productInfoElement = $(productInfoElementId);
    
    errorElement.hide().text('');
    productInfoElement.hide().html('');

    if (!barcodeValue || barcodeValue.trim() === '') {
      return true;
    }

    const existingProduct = await checkBarcodeExists(barcodeValue, barcodeType, currentProductId);
    
    if (existingProduct) {
      errorElement.text(`${barcodeType === 'unit' ? 'Unit' : 'Case'} barcode already exists!`).show();
      return false;
    } else {
      errorElement.hide();
      productInfoElement.hide();
      return true;
    }
  };

  const submitNewProductForm = async () => {
    const formElement = document.getElementById('addProductForm');
    const formData = new FormData(formElement);

    const product_code = $('#product_code').val();
    if (product_code === '') {
      $('#product_code_error').show();
      return;
    } else if (product_code.length < 3 || product_code.length > 8) {
      $('#product_code_error').text('Product code must be between 3 and 8 characters').show();
      return;
    } else if (!/^[A-Z0-9]+$/.test(product_code)) {
      $('#product_code_error').text('Product code must be alphanumeric and uppercase').show();
      return;
    } else {
      $('#product_code_error').hide();
    }

    const unitBarcode = $('#unit_barcode').val();
    const caseBarcode = $('#case_barcode').val();
    
    let hasBarcodeError = false;

    if (unitBarcode && unitBarcode.trim() !== '') {
      const unitBarcodeValid = await handleBarcodeBlur(unitBarcode, 'unit', '#unit_barcode_error', '#unit_barcode_product_info');
      if (!unitBarcodeValid) {
        hasBarcodeError = true;
      }
    }

    if (caseBarcode && caseBarcode.trim() !== '') {
      const caseBarcodeValid = await handleBarcodeBlur(caseBarcode, 'case', '#case_barcode_error', '#case_barcode_product_info');
      if (!caseBarcodeValid) {
        hasBarcodeError = true;
      }
    }

    if (hasBarcodeError) {
      Swal.fire({
        title: 'Error!',
        text: 'Duplicate barcode detected. Please use a different barcode.',
        icon: 'error',
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          popup: 'swal-high-z-index'
        }
      });
      return;
    }

    try {
      const response = await fetch(`${config.api_url}/ws-add-product`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: 'Success!',
          text: 'Product added successfully.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-high-z-index'
          }
        });

        const bsModal = window.bootstrap.Modal.getInstance(modalRef.current);
        if (bsModal) bsModal.hide();

        const table = $("#productListTable").DataTable();
        table.ajax.reload();

        formElement.reset();
      } else {
        Swal.fire({
          title: 'Error!',
          text: result.message || 'An error occurred while adding the product.',
          icon: 'error',
          timer: 3000,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-high-z-index'
          }
        });
      }
    } catch (error) {
      console.error("Error adding product:", error);
      Swal.fire({
        title: 'Error!',
        text: 'Network error occurred while adding the product.',
        icon: 'error',
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          popup: 'swal-high-z-index'
        }
      });
    }
  };

  const getEditModal = () => {
    fetchSupplierData();
  }

  const fetchBrandData = async () => {
    const apiUrl = `${config.api_url}/ws-get-brand`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });
      const data = await response.json();
      setBrandData(data.brands);
    } catch (error) {
      console.error("Error fetching brands data:", error);
    }
  };

  const fetchWarehouseData = async () => {
    const apiUrl = `${config.api_url}/ws-get-warehouse`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });
      const data = await response.json();
      setWarehouse(data.warehouse);
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const fetchVatData = async () => {
    const apiUrl = `${config.api_url}/ws-get-vat`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });
      const data = await response.json();
      setVatData(data.vat);
    } catch (error) {
      console.error("Error fetching vat data:", error);
    }
  };

  const AddProduct = () => {
    fetchBrandData();
    fetchSupplierData();
    fetchCategoryData();
    fetchVatData();
    ClearAddProductForm();
  }

  const ClearAddProductForm = () => {
    $('#product_desc').val('');
    $('#product_code').val('');
    $('#category_id').val('');
    $('#supplier_id').val('');
    $('#brandlist').val('');
    $('#pack').val('');
    $('#size').val('');
    $('#unit_barcode').val('');
    $('#case_barcode').val('');
    $('#gross_weight').val('');
    $('#net_weight').val('');
    $('#cost_price').val('');
    $('#sell_price').val('');
    $('#add_cbm').val('');
    $('#add_length').val('');
    $('#add_width').val('');
    $('#add_height').val('');
    $('#min_threshold_qty').val('');
    $('#pallet_quantity').val('');
    $('#layer_quantity').val('');
  }

  const getCBM = () => {
    const unitConversionToMM = {
      'mm': 1,
      'cm': 10,
      'in': 25.4,
    };

    let d = 0;

    const a = parseFloat($('#add_width').val());
    const b = parseFloat($('#add_height').val());
    const c = parseFloat($('#add_length').val());

    const e = parseFloat($('#length').val());
    const f = parseFloat($('#width').val());
    const g = parseFloat($('#height').val());

    if (a && b && c) {
      const a_length_unit = $('#length_unit').val();
      const a_width_unit = $('#width_unit').val();
      const a_height_unit = $('#height_unit').val();

      const lengthInMM = c * unitConversionToMM[a_length_unit];
      const widthInMM = a * unitConversionToMM[a_width_unit];
      const heightInMM = b * unitConversionToMM[a_height_unit];

      d = (lengthInMM * widthInMM * heightInMM) / 1e9;

      console.log(d);
      $('#add_cbm').val((d).toFixed(6));
    } else if (e && f && g) {
      const e_length_unit = $('#edit_length_unit').val();
      const e_width_unit = $('#edit_width_unit').val();
      const e_height_unit = $('#edit_height_unit').val();

      const lengthInMM = e * unitConversionToMM[e_length_unit];
      const widthInMM = f * unitConversionToMM[e_width_unit];
      const heightInMM = g * unitConversionToMM[e_height_unit];

      d = (lengthInMM * widthInMM * heightInMM) / 1e9;

      console.log(d);
      $('#edit_cbm').val((d).toFixed(6));
    }
  };

  const handleVatValidation = (e) => {
    const value = e.target.value;
    const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);
    if (value !== alphanumericOnly) {
      e.target.value = alphanumericOnly;
    }
  };

  const handleClearForm = () => {
    alert('fff');
  };

  return (
    <div>
      <style>
        {`
          .swal-high-z-index {
            z-index: 999999999 !important;
          }
          .swal2-container {
            z-index: 999999999 !important;
          }
          
          /* DataTable Container */
          #productListTable_wrapper {
            display: flex;
            flex-direction: column;
          }
          
          /* Scroll containers */
          #productListTable_wrapper .dataTables_scroll {
            position: relative;
            clear: both;
          }
          
          #productListTable_wrapper .dataTables_scrollHead {
            overflow: hidden !important;
            border-bottom: 1px solid #ddd;
            margin-bottom: 0;
          }
          
          #productListTable_wrapper .dataTables_scrollBody {
            overflow-x: auto !important;
            overflow-y: auto !important;
            max-height: calc(100vh - 350px);
          }
          
          /* Table layout */
          #productListTable_wrapper .dataTables_scrollHead table,
          #productListTable_wrapper .dataTables_scrollBody table {
            width: 100% !important;
            table-layout: fixed !important;
            margin: 0 !important;
            border-collapse: separate;
            border-spacing: 0;
          }
          
          /* Inner wrappers */
          #productListTable_wrapper .dataTables_scrollHeadInner,
          #productListTable_wrapper .dataTables_scrollBodyInner {
            box-sizing: border-box;
            margin: 0 !important;
          }
          
          #productListTable_wrapper .dataTables_scrollHeadInner {
            overflow: hidden !important;
          }
          
          #productListTable_wrapper .dataTables_scrollBodyInner {
            overflow: visible !important;
          }
          
          /* Cell styling */
          #productListTable_wrapper .dataTables_scrollHead thead th,
          #productListTable_wrapper .dataTables_scrollBody tbody td {
            vertical-align: middle;
            padding: 8px;
            box-sizing: border-box;
            border-left: 1px solid #ddd;
            border-right: 1px solid #ddd;
            white-space: normal;
            word-wrap: break-word;
            overflow-wrap: break-word;
          }
          
          #productListTable_wrapper .dataTables_scrollHead thead th:first-child,
          #productListTable_wrapper .dataTables_scrollBody tbody td:first-child {
            border-left: none;
          }
          
          #productListTable_wrapper .dataTables_scrollHead thead th:last-child,
          #productListTable_wrapper .dataTables_scrollBody tbody td:last-child {
            border-right: none;
          }
          
          /* Pagination and info */
          #productListTable_wrapper .dataTables_paginate,
          #productListTable_wrapper .dataTables_info {
            flex-shrink: 0;
            margin-top: 15px;
            margin-bottom: 15px;
            position: relative !important;
            z-index: 10;
          }
          
          #productListTable_wrapper .dataTables_paginate {
            float: right !important;
            text-align: right !important;
            margin-left: auto !important;
            width: auto !important;
          }
          
          #productListTable_wrapper .dataTables_info {
            float: left !important;
            margin-right: auto !important;
          }
          
          #productListTable_wrapper .bottom {
            padding: 10px 0;
            clear: both;
            margin-bottom: 5px !important;
          }
          
          #productListTable_wrapper .bottom .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0;
            width: 100%;
          }
          
          #productListTable_wrapper .bottom .col-sm-6:last-child {
            text-align: right !important;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          
          #productListTable_wrapper .bottom .col-sm-6:first-child {
            text-align: left !important;
            display: flex;
            align-items: center;
          }
          
          #productListTable_wrapper .dataTables_paginate ul {
            display: flex;
            align-items: center;
            margin: 0;
            padding: 0;
            list-style: none;
          }
          
          #productListTable_wrapper .dataTables_paginate li {
            display: inline-flex;
            align-items: center;
            margin: 0 2px;
          }
          
          /* Ensure verical-scrl-wrapper works with DataTable */
          .verical-scrl-wrapper#style-3 {
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 555px;
            margin: 0px auto 20px auto;
            padding: 0;
            min-height: 400px;
            width: 100%;
            box-sizing: border-box;
            position: relative;
          }
          
          /* When using verical-scrl-wrapper, DataTable should not create scroll containers */
          .verical-scrl-wrapper#style-3 #productListTable_wrapper .dataTables_scroll {
            position: relative;
          }
          
          .verical-scrl-wrapper#style-3 #productListTable_wrapper .dataTables_scrollBody {
            overflow: visible !important;
            max-height: none !important;
          }
          
          .verical-scrl-wrapper#style-3 #productListTable_wrapper .dataTables_scrollHead {
            overflow: visible !important;
          }
          
          /* Ensure table has consistent width */
          .verical-scrl-wrapper#style-3 #productListTable {
            width: 100% !important;
            table-layout: auto;
          }
        `}
      </style>

      {/* Add Product Modal */}
      <div className="modal fade" id="add-product" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Product</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                <form id="addProductForm">
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                      <label htmlFor="product_code" className="col-sm-6 col-form-label">Product Code <span className='red'>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="product_code"
                        id="product_code"
                        maxLength="8"
                        minLength="3"
                        pattern="[A-Z0-9]+"
                        title="Product code must be 3-8 characters, alphanumeric and uppercase"
                        onInput={(e) => {
                          e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                        }}
                        required
                      />
                      <small className="form-text text-muted">3-8 characters, alphanumeric, uppercase only</small>
                      <span id="product_code_error" style={{ color: 'red', display: 'none' }}> Please enter product code </span>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                      <label htmlFor="desc" className="col-sm-6 col-form-label">Product Description <span className='red'>*</span></label>
                      <input type="text" className="form-control" name="product_desc" id="product_desc" />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="compType" className="col-sm-6 col-form-label">Category</label>
                      <select name="category_id" id="category_id" className="form-select orgselect" defaultValue=''>
                        <option value="" disabled>Select Category</option>
                        {categoryData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Supplier</label>
                      <select name="supplier_id" id="supplier_id" className="form-select orgselect" required="" defaultValue=''>
                        <option value="" disabled>Select Supplier</option>
                        {supplierData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Brand</label>
                      <select name="brand_id" id="brandlist" className="form-select orgselect" required="" defaultValue=''>
                        <option value="" disabled>Select Brand</option>
                        {brandData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="displayName" className="col-sm-6 col-form-label">VAT % <span className='red'>*</span></label>
                      <select name="vat_id" className="form-select orgselect" onChange={handleVatValidation}>
                        {vatData.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Pack</label>
                      <input type="text" className="form-control" name="pack" id="pack" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Size</label>
                      <input type="text" className="form-control" name="size" id="size" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Case Per Pallet</label>
                      <input type="text" className="form-control" name="pallet_quantity" id="pallet_quantity" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Layer Quantity</label>
                      <input type="text" className="form-control" name="layer_quantity" id="layer_quantity" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Unit Barcode</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="unit_barcode" 
                        id="unit_barcode"
                        onBlur={(e) => handleBarcodeBlur(e.target.value, 'unit', '#unit_barcode_error', '#unit_barcode_product_info')}
                      />
                      <span id="unit_barcode_error" style={{ color: 'red', display: 'none' }}></span>
                      <div id="unit_barcode_product_info" style={{ display: 'none' }}></div>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Case Barcode</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="case_barcode" 
                        id="case_barcode"
                        onBlur={(e) => handleBarcodeBlur(e.target.value, 'case', '#case_barcode_error', '#case_barcode_product_info')}
                      />
                      <span id="case_barcode_error" style={{ color: 'red', display: 'none' }}></span>
                      <div id="case_barcode_product_info" style={{ display: 'none' }}></div>
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="displayName" className="col-sm-6 col-form-label">Minimum Threshold Quantity </label>
                      <input type="text" className="form-control" name="min_threshold_qty" id="min_threshold_qty" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Gross Weight</label>
                      <input type="text" className="form-control" name="gross_weight" placeholder="in Kg" id="gross_weight" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Net Weight</label>
                      <input type="text" className="form-control" name="net_weight" placeholder="in Kg" id="net_weight" />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Length</label>
                      <input type="text" className="form-control smallinput" onChange={getCBM} name="length" id="add_length" />
                      <select name="length_unit" id="length_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Width</label>
                      <input type="text" className="form-control smallinput" name="width" onChange={getCBM} id="add_width" />
                      <select name="width_unit" id="width_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Height</label>
                      <input type="text" className="form-control smallinput" onChange={getCBM} name="height" id="add_height" />
                      <select name="height_unit" id="height_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Cost Price</label>
                      <input type="text" className="form-control" name="cost_price" id="cost_price" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Sell Price</label>
                      <input type="text" className="form-control" name="sell_price" id="sell_price" />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="inputEmail5" className="col-form-label">CBM (Cubic meter)</label>
                      <input type="text" className="form-control" name="cbm" id="add_cbm" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="displayName" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-3">
                      <label className="switch">
                        <input className="switch-input" type="checkbox" name="status" defaultChecked />
                        <span className="switch-label" data-on="Active" data-off="Inactive"></span> 
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                    <label htmlFor="compType" className="col-sm-3 col-form-label">Product Image</label>
                    <div className="col-sm-3">
                      <input className="form-control" type="file" name="product_image" />
                    </div>
                  </div>
                  <hr />
                  <div className="row padd-l-13px">
                    <div className="col-sm-12">
                      <Link to="#" onClick={submitNewProductForm} className="popup-innerbtn-common right">Save</Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Product Modal */}
      <div className="modal fade" id="edit-product" tabIndex="-1" ref={updateModalRef}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Product</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                <form id="editProductForm">
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                        <label htmlFor="edit_product_code" className="col-sm-6 col-form-label">Product Code <span className='red'>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="product_code"
                          id="edit_product_code"
                          maxLength="8"
                          minLength="3"
                          pattern="[A-Z0-9]+"
                          title="Product code must be 3-8 characters, alphanumeric and uppercase"
                          onInput={(e) => {
                            e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                          }}
                          required
                        />
                        <small className="form-text text-muted">3-8 characters, alphanumeric, uppercase only</small>
                        <span id="edit_product_code_error" style={{ color: 'red', display: 'none' }}> Please enter product code </span>
                      </div>
                    <div className="col-sm-6">
                      <input type="hidden" className="form-control" name="product_id" id="edit_product_id" />
                      <label htmlFor="desc" className="col-sm-6 col-form-label">Product Description <span className='red'>*</span></label>
                      <input type="text" className="form-control" name="product_desc" id="edit_product_desc" />
                      <span id="edit_product_desc_error" style={{ color: 'red', display: 'none' }}> Please enter product description </span>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                      <label htmlFor="compType" className="col-sm-6 col-form-label">Category</label>
                      <select name="category_id" id="edit_category_id" className="form-select orgselect" defaultValue=''>
                        <option value="" disabled>Select Category</option>
                        {categoryData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Supplier</label>
                      <select name="supplier_id" id="edit_supplier_id" className="form-select orgselect" required="" defaultValue=''>
                        <option value="" disabled>Select Supplier</option>
                        {supplierData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Brand</label>
                      <select name="brand_id" id="edit_brand_id" className="form-select orgselect" required="" defaultValue=''>
                        <option value="" disabled>Select Brand</option>
                        {brandData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    </div>

                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                      <label htmlFor="displayName" className="col-sm-6 col-form-label">VAT % <span className='red'>*</span></label>
                      <select name="vat_id" id="edit_vat_id" className="form-select orgselect" defaultValue='' onChange={handleVatValidation}>
                        <option value="" disabled>Select VAT</option>
                        {vatData.map((item, index) => (
                          <option key={index} value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Pack</label>
                      <input type="text" className="form-control" name="pack" id="edit_pack" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Size</label>
                      <input type="text" className="form-control" name="size" id="edit_size" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Case Per Pallet</label>
                      <input type="text" className="form-control" name="pallet_quantity" id="edit_pallet_quantity" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Layer Quantity</label>
                      <input type="text" className="form-control" name="layer_quantity" id="edit_layer_quantity" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Unit Barcode</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="unit_barcode" 
                        id="edit_unit_barcode"
                        onBlur={(e) => {
                          const currentProductId = $('#edit_product_id').val();
                          handleBarcodeBlur(e.target.value, 'unit', '#edit_unit_barcode_error', '#edit_unit_barcode_product_info', currentProductId);
                        }}
                      />
                      <span id="edit_unit_barcode_error" style={{ color: 'red', display: 'none' }}></span>
                      <div id="edit_unit_barcode_product_info" style={{ display: 'none' }}></div>
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Case Barcode</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="case_barcode" 
                        id="edit_case_barcode"
                        onBlur={(e) => {
                          const currentProductId = $('#edit_product_id').val();
                          handleBarcodeBlur(e.target.value, 'case', '#edit_case_barcode_error', '#edit_case_barcode_product_info', currentProductId);
                        }}
                      />
                      <span id="edit_case_barcode_error" style={{ color: 'red', display: 'none' }}></span>
                      <div id="edit_case_barcode_product_info" style={{ display: 'none' }}></div>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-6">
                      <label htmlFor="displayName" className="col-sm-6 col-form-label">Minimum Threshold Quantity </label>
                      <input type="text" className="form-control" name="min_threshold_qty" id="edit_min_threshold_qty" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Gross Weight</label>
                      <input type="text" className="form-control" name="gross_weight" placeholder="in Kg" id="edit_grossWeight" />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="inputEmail5" className="col-form-label">Net Weight</label>
                      <input type="text" className="form-control" name="net_weight" placeholder="in Kg" id="edit_netWeight" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Length</label>
                      <input type="text" className="form-control smallinput" onChange={getCBM} name="length" id="length" />
                      <select name="length_unit" id="edit_length_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Width</label>
                      <input type="text" className="form-control smallinput" onChange={getCBM} name="width" id="width" />
                      <select name="width_unit" id="edit_width_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="inputState" className="col-form-label" style={{ width: '100%' }}>Height</label>
                      <input type="text" className="form-control smallinput" onChange={getCBM} name="height" id="height" />
                      <select name="height_unit" id="edit_height_unit" onChange={getCBM} className="form-select smallselect">
                        <option value='mm'>MM</option>
                        <option value='cm'>CM</option>
                        <option value='in'>IN</option>
                      </select>
                    </div>
                    <div className="col-sm-2">
                      <label htmlFor="inputEmail5" className="col-form-label">Cost Price</label>
                      <input type="text" className="form-control" name="cost_price" id="edit_cost_price" />
                    </div>
                    <div className="col-sm-2">
                      <label htmlFor="inputEmail5" className="col-form-label">Sell Price</label>
                      <input type="text" className="form-control" name="sell_price" id="edit_sell_price" />
                    </div>
                    <div className="col-sm-2">
                      <label htmlFor="inputEmail5" className="col-form-label">CBM (Cubic meter)</label>
                      <input type="text" className="form-control" name="cbm" id="edit_cbm" />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="displayName" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-3">
                      <label className="switch">
                        <input className="switch-input" type="checkbox" name="status" id="edit_status" />
                        <span className="switch-label" data-on="Active" data-off="Inactive"></span> 
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                    <label htmlFor="compType" className="col-sm-2 col-form-label">Product Image</label>
                    <div className="col-sm-4">
                      <input className="form-control" type="file" name="product_image" id="edit_product_image" value="" />
                      <img name="prev_image" id="edit_prev_image" width='100px' height='100px' title="Product Image" />
                      <input type="hidden" className="form-control" name="oldPdtImg" id="edit_oldPdtImg" />
                    </div>
                  </div>
                  <hr />
                  <div className="row padd-l-13px">
                    <div className="col-sm-12">
                      <Link to="#" onClick={updateProductForm} className="popup-innerbtn-common right">Update</Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <ViewProduct product_id={viewProductId} />
      
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt; 
              <a href="Dashboard">Master</a> &gt; 
              <span className="last-crumb">Product</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="show-order-area dashboard">
                <div className="dashform">
                  <div className="topsearch-area">
                    <div className="row">
                      <div className="col-12 col-lg-4 col-sm-4">
                        <div className="row">
                          <label htmlFor="inputText" className="col-sm-5 col-form-label">Search Code / Description</label>
                          <div className="col-sm-7">
                            <input 
                              type="text" 
                              className="search-area form-control" 
                              autoComplete='off' 
                              onChange={(e) => setAjaxSearch(e.target.value)} 
                              placeholder="Search" 
                              name="product_name" 
                              id="product_name" 
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-3 col-sm-3">
                        <div className="row">
                          <label htmlFor="inputText" className="col-sm-4 col-form-label">Stock Type</label>
                          <div className="col-sm-8">
                            <select
                              name="stock_type"
                              id="stock_type"
                              onChange={setAjaxSearch}
                              className="form-select"
                              aria-label="Default select example">
                              <option value="all">All</option>
                              <option value="free_stock">Free Stock</option>
                              <option value='on_po'>On P.O.</option>
                              <option value='on_so'>On S.O.</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-2 col-sm-2">
                        <div style={{ float: "right" }}>
                          <Link 
                            className="create-catalogue-btn" 
                            onClick={AddProduct} 
                            data-bs-toggle="modal"
                            data-bs-target="#add-product"
                          >
                            Add New Product
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ width: "100%", float: "left" }}>
                  <div className="common-table product-table">
                    <div className="verical-scrl-wrapper" id="style-3">
                      <table className="table table-bordered dataTable" id="productListTable" ref={tableRef}>
                    <thead>
                      <tr>
                            <th>Code</th>
                            <th>Product Description</th>
                            <th>Pack</th>
                        <th>Size</th>
                        <th>Unit Barcode</th>
                            <th>Case Barcode</th>
                            <th>Pallet Qty</th>
                            <th>Layer Qty</th>
                            <th>Gross Wt</th>
                            <th>Net Wt</th>
                            <th>CBM</th>
                            <th>Category</th>
                            <th>Sell price</th>
                            <th>F. Stk</th>
                            <th>On SO</th>
                            <th>On PO</th>
                            <th>Stock</th>
                            <th>Status</th>
                            <th>Action</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Products;
